/*
 * @Description: 运力管理（收款人）
 * @Author: WangYuhan
 * @Date: 2022-11-01 16:43:01
 * @LastEditTime: 2024-07-17 17:28:34
 * @LastEditors: lijinpeng
 */

import { get, post, prefix } from './base';

//  收款人列表
export function captainList(params) {
  return get(`${prefix}collect/pageCollectInfo`, params);
}

//  收款人列表
export function getCollectPageList(params) {
  return get(`${prefix}collect/pageList`, params);
}

//  收款人详情
export function captainInfo(params) {
  return get(`${prefix}collect/collectDetail`, params);
}

// 收款人删除
export function captainDelete(params) {
  return post(`${prefix}collect/delete`, params);
}

// 收款人编辑/新增
export function captainUpdate(params) {
  return post(`${prefix}collect/saveAndUpdate`, params);
}

// 设置默认收款人
export function vehicleDefault(params) {
  return post(`${prefix}collect/setDefault`, params);
}

// 取消默认收款人
export function cancelCollectDefault(params) {
  return post(`${prefix}collect/cancelDefault`, params);
}

// 银行卡三要素验证
export function bankCardTreeVerification(params) {
  return get(`${prefix}common/bankCardTreeVerification`, params);
}

// 根据卡号返回总行名称
export function getBankByCard(params) {
  return get(`${prefix}common/bank/getBankByCard`, params);
}

// 获取高德key
export function getAMapKeys(params) {
  return get(`${prefix}config/amap/configration`, params);
}

// 查询当前企业选择的网货平台
export function findChannelInfoByCorp(params) {
  return get(`${prefix}waybillSettlement/findChannelInfoByCorp`, params);
}

//  收款人 + 司机 模糊查询列表
export function getCollectionList(params) {
  return get(`${prefix}collect/collectionList`, params);
}

//运单-司机收款信息
export function getWaybillDriverBank(params) {
  return get(`${prefix}waybill/v2/getWaybillDriverBank`, params);
}
